import React, { useRef, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import Button from '@components/Button';
import C from '@assets/themes/colors';

const WarningScreen:React.FC<IProps> = (props) => {
  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && ref.current===event.target) {
          props.setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const outsideRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  useOutsideAlerter(outsideRef);

  const isError = props.options.errorNote !== "" ? true : false;

  const renderErrorArgument = (value:string) => {
    var errorName = value.toString();
    if (errorName.length > 45)
      errorName = errorName.substr(0, 45) + "..."
    return errorName;
  }

  return (
    <S.Root ref={outsideRef} style={{
      display: props.open ? 'flex' : 'none',
    }} >
      <S.WarningBox isError={false} >
        <S.Title>
          {props.options.title}
        </S.Title>
        <S.Content>
          <S.Subtitle>
            {props.options.subtitle}
          </S.Subtitle>
          {
            props.options.errorNote !== "" &&
            <S.ErrorContainer>
              <S.ErrorNotes>
                <S.Error>Error: </S.Error>
                {props.options.errorNote}
              </S.ErrorNotes>
              {
                props.options.errorArguments.length > 0 &&
                props.options.errorArguments.map((argument: string, index: number) => {
                  return (
                    <S.ErrorArguments key={index} >
                      {renderErrorArgument(argument)}
                    </S.ErrorArguments>
                  )
                })
              }
            </S.ErrorContainer>
          }
        </S.Content>
        <S.ActionsContainer>
          {
            props.options.actionTitle !== "" &&
            <S.Action>
              <Button
                label={props.options.actionTitle}
                style={{
                  marginRight: 12, 
                  backgroundColor: "transparent", 
                  border: `1px solid ${isError ? C.DARK_ORANGE : C.DARK_BLUE}`, 
                  hoverBackgroundColor: `${isError ? C.DARK_ORANGE : C.DARK_BLUE}22`,
                }}
                labelStyle={{color: isError ? C.DARK_ORANGE : C.DARK_BLUE}}
                onClick={props.options.secondaryFunction === undefined ? () => {props.setOpen(false)} : props.options.secondaryFunction}
              />
            </S.Action>
          }
          <S.Action>
            <Button
              label={props.options.closeActionTitle}
              style={{
                backgroundColor: isError ? C.DARK_ORANGE : C.DARK_BLUE, 
                flexGrow: 0, 
                hoverBackgroundColor: `${isError ? C.DARK_ORANGE : C.DARK_BLUE}AA`,
              }} 
              onClick={props.options.actionFunction === undefined ? () => {props.setOpen(false)} : props.options.actionFunction}
            />
          </S.Action>
        </S.ActionsContainer>
      </S.WarningBox>
    </S.Root>
  );
}

export default WarningScreen;